import { doc, getDoc } from "firebase/firestore";
import { firestore as db } from "@/utils/firebase";

/**
 * Check if a user is an admin by UID
 *
 * @param uid - Firebase UID to check
 * @returns True if the user is in the admins collection
 */
export async function isAdmin(uid: string): Promise<boolean> {
  const ref = doc(db, "admins", uid);
  const snap = await getDoc(ref);
  return snap.exists();
}
